import React from "react"
import css from "./HomeBackground.module.scss"

export const HomeBackground = ({ children }) => {
  return (
    <div className={css.wrapper}>
      <div className={css.photo} />
      <div className={css.scrim} />
      <div className={css.noize} />
      <div className={css.content}>{children}</div>
    </div>
  )
}
